<template>
  <header
    class="grid lg:mt-6 lg:min-h-svh lg:grid-cols-2 lg:pt-navbar-height xl:mt-0"
    :class="[data.badge_show ? 'gap-y-26' : 'gap-y-12', marginBottom]"
  >
    <!-- TEXT -->
    <Container
      v-animate-children-in-from-bottom
      indent="default-left"
      class="relative z-10 pr-container lg:mr-[-25%] lg:mt-16 lg:pr-0 max-lg:order-2 md:pr-container-lg"
    >
      <!-- Surtitle -->
      <p v-if="data.surtitle" class="typo-label-md md:typo-label-lg">
        {{ data.surtitle }}
      </p>

      <!-- title -->
      <h1
        v-if="data.heading"
        class="mb-5 mt-10 typo-heading-xl 2xl:mt-[10vh] lg:mt-[13vh] sm:typo-display-lg"
        v-html="data.heading"
      />

      <!-- Text -->
      <div
        v-if="data.text"
        class="typo-body-2xl sm:typo-body-3xl"
        v-html="data.text"
      />

      <!-- Link -->
      <div v-if="data.link && data.link_text" class="mt-3 lg:mt-14">
        <AppLink :to="data.link">
          {{ data.link_text }}
        </AppLink>
      </div>
    </Container>

    <!-- IMAGE -->
    <div
      v-if="data.image"
      v-animate-in-from-right
      class="relative max-lg:order-1"
    >
      <div class="relative size-full max-h-[33vh] lg:max-h-[calc(100svh-var(--navbar-height)-10rem)]">
        <!-- Image -->
        <AppImage
          :alt="useMapAltText(data.image)"
          class="size-full rounded-br-100 object-cover lg:rounded-br-none lg:rounded-tl-100"
          :style="`object-position: ${data.image.focus_css};`"
          :src="data.image"
          loading="eager"
        />
        <!-- Gradient overlay -->
        <div class="absolute inset-0 gradient pointer-events-none max-lg:hidden" />

        <!-- Badge -->
        <Badge
          v-if="data.badge_show"
          class="absolute bottom-0 right-[10%] translate-y-1/2 lg:right-container-desktop"
          :badge-color="data.badge_color.value"
          :title="data.badge_title"
          :link="data.badge_link"
        />
      </div>
    </div>
  </header>
</template>

<script lang="ts" setup>
import type { HerosMainHeroContentFragment } from '#gql'

const props = defineProps<{
  data: Enforce<HerosMainHeroContentFragment>
  firstComponent: string | null
}>()

const marginBottom = computed(() => {
  if (props.firstComponent === 'text' && props.data.badge_show) {
    return '2xl:-mb-40 lg:-mb-24'
  }

  if (props.firstComponent === 'text' && !props.data.badge_show) {
    return 'lg:-mb-40'
  }

  if (props.firstComponent !== 'text' && props.data.badge_show) {
    return 'mb-20 lg:mb-0'
  }

  return 'mb-20 lg:-mb-16'
})
</script>

<style scoped>
.gradient {
  background: linear-gradient(90deg,rgba(255, 255, 255, 0.5) 0%, transparent 50%);
}
 </style>
